import { Popconfirm } from 'antd';
import React, { forwardRef, useImperativeHandle, useRef, useEffect, useState } from 'react';
import {
  setTableColumnSelection,
  clearAzureSavingsPlanOrdersMessages,
  azureSavingsPlanOrdersSelector,
} from '../../../../store/azure/azureSavingsPlanOrders/azureSavingsPlanOrders.reducer';
import { useAppDispatch, useAppSelector } from '../../../../store/app.hooks';
import {
  deleteAzureSavingsPlanOrders,
  searchAzureSavingsPlanOrders,
} from '../../../../store/azure/azureSavingsPlanOrders/azureSavingsPlanOrders.action';
import _ from 'lodash';
import azureSavingsPlanOrdersService from '../../../../services/azure/azureSavingsPlanOrders/azureSavingsPlanOrders.service';
import {
  FilterByDateSwap,
  FilterWithSwapOption,
} from '../../../../common/components/DataTable/DataTableFilters';
import { IMainTable, ISearch } from '../../../../common/models/common';
import { useHistory } from 'react-router-dom';
import DataTable from '../../../../common/components/DataTable';
import ability, { Can } from '../../../../common/ability';
import { Action, Page } from '../../../../common/constants/pageAction';
import { showDateFromApi } from '../../../../common/helperFunction';

const MainTable: React.ForwardRefRenderFunction<unknown, IMainTable> = (props, ref) => {
  const {
    setSelectedId,
    setShowSelectedListModal,
    setValuesForSelection,
    isMultiple,
    tableButtons,
  } = props;
  const azureSavingsPlanOrders = useAppSelector(azureSavingsPlanOrdersSelector);
  const dispatch = useAppDispatch();
  const dataTableRef = useRef(null);
  const history = useHistory();
  const [ObjectForColumnFilter, setObjectForColumnFilter] = useState({});

  useImperativeHandle(ref, () => ({
    refreshData() {
      dataTableRef?.current.refreshData();
    },
  }));

  useEffect(() => {
    if (isMultiple) {
      dataTableRef?.current.getValuesForSelection();
    }
  }, [isMultiple]);

  const exportExcelFile = (searchData: ISearch) => {
    return azureSavingsPlanOrdersService.exportExcelFile(searchData);
  };

  const FilterBySwap = (dataIndex: string, form, isRelativeDropDownFlag?: boolean) => {
    return FilterWithSwapOption(
      dataIndex,
      azureSavingsPlanOrders.search.tableName,
      form,
      null,
      ObjectForColumnFilter,
      null,
      null,
      isRelativeDropDownFlag
    );
  };

  const FilterByDateSwapTable = (dataIndex: string, tableName: string, form: any) => {
    return FilterByDateSwap(dataIndex, tableName, form, null, ObjectForColumnFilter);
  };

  const getTableColumns = (form) => {
    return [
      {
        title: <span className="dragHandler">ID</span>,
        column: 'id',
        sorter: true,
        ellipsis: true,
        children: [
          {
            title: FilterBySwap('id', form),
            dataIndex: 'id',
            key: 'id',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Tenant Name</span>,
        column: 'TenantId',
        sorter: true,
        children: [
          {
            title: FilterBySwap('tenant_id', form, true),
            dataIndex: 'tenant_name',
            key: 'tenant_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Company Name</span>,
        column: 'CompanyId',
        sorter: true,
        children: [
          {
            title: FilterBySwap('company_id', form, true),
            dataIndex: 'company_name',
            key: 'company_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Bu Name</span>,
        column: 'BU_Id',
        sorter: true,
        children: [
          {
            title: FilterBySwap('bu_id', form, true),
            dataIndex: 'bu_name',
            key: 'bu_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Savings Plan Order Id</span>,
        column: 'SavingsPlanOrderId',
        sorter: true,
        children: [
          {
            title: FilterBySwap('savings_plan_order_id', form),
            dataIndex: 'savings_plan_order_id',
            key: 'savings_plan_order_id',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Display Name</span>,
        column: 'DisplayName',
        sorter: true,
        children: [
          {
            title: FilterBySwap('display_name', form),
            dataIndex: 'display_name',
            key: 'display_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Term</span>,
        column: 'Term',
        sorter: true,
        children: [
          {
            title: FilterBySwap('term', form),
            dataIndex: 'term',
            key: 'term',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Provisioning State</span>,
        column: 'ProvisioningState',
        sorter: true,
        children: [
          {
            title: FilterBySwap('provisioning_state', form),
            dataIndex: 'provisioning_state',
            key: 'provisioning_state',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Billing Plan</span>,
        column: 'BillingPlan',
        sorter: true,
        children: [
          {
            title: FilterBySwap('billing_plan', form),
            dataIndex: 'billing_plan',
            key: 'billing_plan',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Billing Account Id</span>,
        column: 'BillingAccountId',
        sorter: true,
        children: [
          {
            title: FilterBySwap('billing_account_id', form),
            dataIndex: 'billing_account_id',
            key: 'billing_account_id',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Commitment Amount</span>,
        column: 'CommitmentAmount',
        sorter: true,
        children: [
          {
            title: FilterBySwap('commitment_amount', form),
            dataIndex: 'commitment_amount',
            key: 'commitment_amount',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Commitment Currency Code</span>,
        column: 'CommitmentCurrencyCode',
        sorter: true,
        children: [
          {
            title: FilterBySwap('commitment_currency_code', form),
            dataIndex: 'commitment_currency_code',
            key: 'commitment_currency_code',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Commitment Grain</span>,
        column: 'CommitmentGrain',
        sorter: true,
        children: [
          {
            title: FilterBySwap('commitment_grain', form),
            dataIndex: 'commitment_grain',
            key: 'commitment_grain',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Date Added</span>,
        column: 'DateAdded',
        sorter: true,
        children: [
          {
            title: FilterByDateSwapTable('date_added', azureSavingsPlanOrders.search.tableName, form),
            dataIndex: 'date_added',
            key: 'date_added',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">Date Modified</span>,
        column: 'DateModified',
        sorter: true,
        children: [
          {
            title: FilterByDateSwapTable('date_modified', azureSavingsPlanOrders.search.tableName, form),
            dataIndex: 'date_modified',
            key: 'date_modified',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
    ];
  };

  const removeAzureSavingsPlanOrders = (id: number) => {
    dispatch(deleteAzureSavingsPlanOrders(id));
  };

  const tableAction = (_unused, data: any) => (
    <div className="btns-block">
      <Can I={Action.Update} a={Page.AzureSavingsPlanOrders}>
        <a
          className="action-btn"
          onClick={() => {
            setSelectedId(data.id);
            history.push(`/azure/azure-savings-plan-orders/${data.id}`);
          }}
        >
          <img src={`${process.env.PUBLIC_URL}/assets/images/ic-edit.svg`} alt="" />
        </a>
      </Can>
      <Can I={Action.Delete} a={Page.AzureSavingsPlanOrders}>
        <Popconfirm title="Delete Record?" onConfirm={() => removeAzureSavingsPlanOrders(data.id)}>
          <a href="#" title="" className="action-btn">
            <img src={`${process.env.PUBLIC_URL}/assets/images/ic-delete.svg`} alt="" />
          </a>
        </Popconfirm>
      </Can>
    </div>
  );

  return (
    <>
      <DataTable
        ref={dataTableRef}
        showAddButton={ability.can(Action.Add, Page.AzureSavingsPlanOrders)}
        setSelectedId={setSelectedId}
        tableAction={tableAction}
        exportExcelFile={exportExcelFile}
        getTableColumns={getTableColumns}
        reduxSelector={azureSavingsPlanOrdersSelector}
        searchTableData={searchAzureSavingsPlanOrders}
        clearTableDataMessages={clearAzureSavingsPlanOrdersMessages}
        globalSearchExist={false}
        setTableColumnSelection={setTableColumnSelection}
        setShowSelectedListModal={setShowSelectedListModal}
        setValuesForSelection={setValuesForSelection}
        setObjectForColumnFilter={setObjectForColumnFilter}
        tableButtons={tableButtons}
      />
    </>
  );
};

export default forwardRef(MainTable);
